import React from 'react';
import { Route } from 'react-router-dom';
import Services01 from '../../Pages/Services/Services01';
import provinces from '../../data/provinces.json';
import categories from '../../data/categories.json';
import AboutBelowContent from '../ExperienceBlocks/AboutBelowContent';

// Funzione per convertire il titolo in un path URL-friendly
const titleToPath = (title) => {
  return title
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/'/g, '')
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

// Funzione per formattare il nome della provincia per l'URL
const formatProvinceForUrl = (province) => {
  return province
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/'/g, '-')
    .replace(/\'/g, '-')
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

// Funzione per formattare il nome della provincia per la visualizzazione
const formatProvinceForDisplay = (province) => {
  return province.toUpperCase();
};

export const services = {
  'costruzione-chiavi-in-mano': {
    path: 'costruzione-chiavi-in-mano',
    title: categories['Costruzione Chiaviami In Mano'],
    description: 'Servizi professionali di costruzione chiavi in mano per la tua casa dei sogni',
    longDescription: 'Offriamo un servizio completo di costruzione chiavi in mano, seguendo il progetto dalla fase iniziale fino alla consegna.',
    detailedDescription: [
      'La costruzione chiavi in mano rappresenta la soluzione ideale per chi desidera realizzare la propria casa dei sogni senza preoccupazioni. Il nostro team di professionisti si occupa di ogni aspetto del progetto, dalla progettazione iniziale fino alla consegna delle chiavi.',
      'Grazie alla nostra esperienza pluriennale nel settore delle costruzioni, siamo in grado di garantire risultati eccellenti, rispettando tempistiche e budget stabiliti. Utilizziamo solo materiali di prima qualità e ci avvaliamo di maestranze altamente qualificate.',
      'Il processo di costruzione chiavi in mano inizia con un\'attenta analisi delle esigenze del cliente e del terreno edificabile. I nostri architetti sviluppano il progetto in stretta collaborazione con il committente, curando ogni dettaglio per garantire la massima funzionalità e il rispetto delle normative vigenti.',
      'Durante la fase di costruzione, ogni passaggio viene attentamente monitorato dai nostri tecnici per garantire la massima qualità esecutiva. Dalla posa delle fondamenta fino alle rifiniture, ogni dettaglio viene curato con la massima attenzione.',
      'La sostenibilità ambientale e l\'efficienza energetica sono al centro dei nostri progetti. Utilizziamo tecnologie e materiali all\'avanguardia per garantire il massimo comfort abitativo e il risparmio energetico.',
      'Al termine dei lavori, effettuiamo un controllo completo di tutti gli impianti e delle finiture, assicurandoci che ogni elemento risponda perfettamente alle specifiche progettuali e alle aspettative del cliente.'
    ],
    features: [
      {
        icon: 'ion-ios-home-outline',
        title: 'Progettazione architettonica',
        description: 'Progettiamo la tua casa secondo i tuoi desideri'
      },
      {
        icon: 'ion-ios-gear-outline',
        title: 'Gestione pratiche',
        description: 'Gestiamo tutte le pratiche burocratiche'
      },
      {
        icon: 'ion-ios-star-outline',
        title: 'Costruzione a regola d\'arte',
        description: 'Realizziamo la costruzione con materiali di prima qualità'
      },
      {
        icon: 'ion-ios-checkmark-outline',
        title: 'Finiture di pregio',
        description: 'Cura dei dettagli e finiture personalizzate'
      }
    ],
    images: {
      main: '/images/servizi/costruzioni_chiavi_in_mano.jpg',
      gallery: ['/images/servizi/costruzione-1.jpg', '/images/servizi/costruzione-2.jpg'],
      icon: '/images/servizi/icons/costruzione.png',
      iconWhite: '/images/servizi/icons/costruzione-white.png'
    },
    video: {
      url: 'https://www.youtube.com/embed/XXXXXX',
      thumbnail: '/images/services/video-costruzione-chiavi-in-mano.jpg'
    },
    testimonials: [
      {
        name: 'Marco Rossi',
        role: 'Proprietario Villa',
        text: 'Servizio eccellente, hanno realizzato la casa dei miei sogni rispettando tempi e budget.',
        image: '/images/testimonials/testimone-1.jpg'
      }
    ],
    faq: [
      {
        question: 'Quanto tempo richiede mediamente la costruzione di una villa?',
        answer: 'I tempi di realizzazione variano in base alle dimensioni e alla complessità del progetto, ma mediamente si aggirano intorno ai 12-18 mesi.'
      },
      {
        question: 'Offrite garanzie sul lavoro svolto?',
        answer: 'Sì, tutti i nostri lavori sono coperti da garanzie decennali come previsto dalla legge.'
      }
    ],
    contactInfo: {
      phone: '+39 XXX XXX XXXX',
      email: 'info@rbcostruzioni.it',
      whatsapp: '+39 XXX XXX XXXX'
    }
  },
  'ristrutturazione': {
    path: 'ristrutturazione',
    title: categories['Riustrutturazione'],
    description: 'Servizi professionali di ristrutturazione per rinnovare la tua casa',
    longDescription: 'Trasformiamo i tuoi spazi con interventi di ristrutturazione personalizzati.',
    detailedDescription: [
      'La ristrutturazione di un immobile è un processo complesso che richiede competenza, esperienza e attenzione ai dettagli. Il nostro team di professionisti è specializzato in interventi di ristrutturazione completa, dal rifacimento degli impianti alle finiture di pregio.',
      'Ogni progetto di ristrutturazione inizia con un\'accurata analisi dello stato attuale dell\'immobile. I nostri tecnici effettuano sopralluoghi dettagliati per valutare le condizioni strutturali, impiantistiche e funzionali, identificando le criticità da risolvere e le potenzialità da sviluppare.',
      'La fase di progettazione viene sviluppata in stretta collaborazione con il cliente, tenendo conto delle sue esigenze funzionali ed estetiche. Proponiamo soluzioni innovative per ottimizzare gli spazi e migliorare la qualità abitativa, sempre nel rispetto delle normative vigenti.',
      'Durante i lavori, garantiamo la massima professionalità e pulizia del cantiere. Ogni fase viene eseguita secondo un cronoprogramma dettagliato, minimizzando i disagi per il cliente e garantendo il rispetto dei tempi di consegna.',
      'Particolare attenzione viene dedicata alla scelta dei materiali e delle finiture, selezionando prodotti di alta qualità che garantiscano durabilità e prestazioni eccellenti nel tempo.',
      'Al termine dei lavori, effettuiamo un collaudo completo di tutti gli interventi eseguiti, rilasciando le necessarie certificazioni e garanzie.'
    ],
    features: [
      {
        icon: 'ion-ios-construct-outline',
        title: 'Ristrutturazione completa',
        description: 'Rinnoviamo completamente gli ambienti'
      },
      {
        icon: 'ion-ios-water-outline',
        title: 'Rifacimento bagni',
        description: 'Modernizzazione completa dei servizi'
      },
      {
        icon: 'ion-ios-nutrition-outline',
        title: 'Rifacimento cucine',
        description: 'Progettazione e realizzazione di cucine funzionali'
      },
      {
        icon: 'ion-ios-construct-outline',
        title: 'Opere murarie',
        description: 'Interventi strutturali e modifiche degli spazi'
      }
    ],
    images: {
      main: '/images/servizi/ristrutturazione.jpg',
      gallery: ['/images/servizi/ristrutturazione-1.jpg', '/images/servizi/ristrutturazione-2.jpg'],
      icon: '/images/servizi/icons/ristrutturazione.png',
      iconWhite: '/images/servizi/icons/ristrutturazione-white.png'
    }
  },
  'miglioramento-energetico': {
    path: 'miglioramento-energetico',
    title: categories['Miglioramento energetico'],
    description: 'Soluzioni per l\'efficientamento energetico della tua casa',
    longDescription: 'Miglioriamo l\'efficienza energetica del tuo immobile con soluzioni innovative e sostenibili.',
    detailedDescription: [
      'Il miglioramento energetico degli edifici rappresenta oggi una priorità sia dal punto di vista ambientale che economico. Il nostro team è specializzato nell\'implementazione di soluzioni all\'avanguardia per l\'efficientamento energetico degli immobili.',
      'Il processo inizia con una diagnosi energetica approfondita dell\'edificio, che permette di identificare le principali dispersioni termiche e le inefficienze degli impianti. Questa analisi è fondamentale per definire gli interventi più efficaci in termini di costo-beneficio.',
      'Progettiamo e realizziamo interventi di isolamento termico dell\'involucro edilizio, utilizzando materiali e tecniche all\'avanguardia. Il cappotto termico, abbinato alla sostituzione degli infissi, permette di ridurre significativamente le dispersioni termiche.',
      'Grande attenzione viene dedicata all\'impiantistica, con l\'installazione di sistemi di climatizzazione ad alta efficienza, pompe di calore e impianti fotovoltaici. Questi interventi permettono di ridurre i consumi energetici e le emissioni di CO2.',
      'Tutti i nostri interventi sono progettati per accedere alle detrazioni fiscali previste dalla normativa vigente. Il nostro team si occupa anche della gestione delle pratiche necessarie per l\'ottenimento degli incentivi.',
      'Al termine dei lavori, forniamo al cliente un report dettagliato sugli interventi eseguiti e sui benefici energetici ottenuti, completo delle certificazioni energetiche aggiornate.'
    ],
    benefits: [
      'Risparmio energetico',
      'Comfort abitativo',
      'Valore immobile',
      'Sostenibilità'
    ],
    features: [
      'Cappotto termico',
      'Infissi ad alta efficienza',
      'Impianti fotovoltaici',
      'Pompe di calore'
    ],
    images: {
      main: '/images/services/energetico.jpg',
      gallery: ['/images/services/energetico-1.jpg', '/images/services/energetico-2.jpg'],
      icon: '/images/services/icons/energetico.png',
      iconWhite: '/images/services/icons/energetico-white.png'
    }
  },
  'servizi-fognature': {
    path: 'servizi-fognature',
    title: categories['Servizi Forgniature'],
    description: 'Servizi professionali per impianti fognari',
    longDescription: 'Realizziamo e manuteniamo impianti fognari con tecniche all\'avanguardia.',
    benefits: [
      'Interventi rapidi',
      'Tecnologie avanzate',
      'Manutenzione programmata',
      'Assistenza 24/7'
    ],
    features: [
      'Nuove installazioni',
      'Riparazioni',
      'Videoispezioni',
      'Spurgo'
    ],
    images: {
      main: '/images/servizi/servizi_fognature.png',
      gallery: ['/images/serv izi/fognature-1.jpg', '/images/servizi/fognature-2.jpg'],
      icon: '/images/servizi/icons/fognature.png',
      iconWhite: '/images/servizi/icons/fognature-white.png'
    }
  },
  'coperture': {
    path: 'coperture',
    title: 'Coperture',
    description: 'Realizzazione e manutenzione di coperture per ogni tipo di edificio',
    longDescription: 'Progettiamo e realizziamo coperture di ogni tipo, garantendo impermeabilizzazione e isolamento termico ottimali.',
    benefits: [
      'Protezione dalle intemperie',
      'Isolamento termico',
      'Durabilità nel tempo',
      'Estetica curata'
    ],
    features: [
      'Tetti in tegole',
      'Coperture industriali',
      'Impermeabilizzazioni',
      'Lattoneria'
    ]
  },
  'sistemazione-esterni': {
    path: 'sistemazione-esterni',
    title: 'Sistemazione Esterni',
    description: 'Progettazione e realizzazione di spazi esterni',
    longDescription: 'Valorizziamo gli spazi esterni con soluzioni personalizzate, dal giardino al cortile, creando ambienti accoglienti e funzionali.',
    benefits: [
      'Valorizzazione immobile',
      'Spazi vivibili',
      'Design personalizzato',
      'Materiali resistenti'
    ],
    features: [
      'Pavimentazioni esterne',
      'Giardini e aiuole',
      'Illuminazione',
      'Recinzioni'
    ]
  },
  'movimenti-di-terra': {
    path: 'movimenti-di-terra',
    title: 'Movimenti di Terra',
    description: 'Servizi professionali di movimentazione terra e scavi',
    longDescription: 'Eseguiamo lavori di movimento terra con macchinari specializzati e personale qualificato, garantendo precisione e sicurezza.',
    benefits: [
      'Precisione nelle lavorazioni',
      'Tempistiche rapide',
      'Sicurezza cantiere',
      'Gestione materiali'
    ],
    features: [
      'Scavi e sbancamenti',
      'Livellamenti terreno',
      'Trasporto materiali',
      'Opere di contenimento'
    ]
  },
  'piccoli-impianti-civili': {
    path: 'piccoli-impianti-civili',
    title: 'Piccoli Impianti Civili',
    description: 'Installazione e manutenzione di impianti civili',
    longDescription: 'Realizziamo e manuteniamo impianti civili di piccole dimensioni, garantendo sicurezza ed efficienza.',
    benefits: [
      'Conformità normative',
      'Efficienza energetica',
      'Assistenza continua',
      'Manutenzione programmata'
    ],
    features: [
      'Impianti elettrici',
      'Impianti idraulici',
      'Climatizzazione',
      'Domotica base'
    ]
  },
  'pavimenti-rivestimenti': {
    path: 'pavimenti-rivestimenti',
    title: 'Pavimenti e Rivestimenti',
    description: 'Installazione professionale di pavimenti e rivestimenti',
    longDescription: 'Realizziamo pavimentazioni e rivestimenti di alta qualità, utilizzando i migliori materiali e tecniche di posa.',
    benefits: [
      'Vasta scelta materiali',
      'Posa professionale',
      'Durata nel tempo',
      'Design personalizzato'
    ],
    features: [
      'Pavimenti in ceramica',
      'Rivestimenti bagno',
      'Pavimenti in legno',
      'Rivestimenti decorativi'
    ]
  },
  'pitture': {
    path: 'pitture',
    title: 'Pitture',
    description: 'Servizi professionali di pittura per interni ed esterni',
    longDescription: 'Realizziamo lavori di pittura e decorazione per interni ed esterni, utilizzando prodotti di qualità e tecniche innovative.',
    benefits: [
      'Finiture di pregio',
      'Prodotti certificati',
      'Protezione superfici',
      'Personalizzazione'
    ],
    features: [
      'Tinteggiatura interni',
      'Pitture esterni',
      'Decorazioni',
      'Trattamenti antimuffa'
    ]
  }
};

export const generateSeoRoutes = () => {
  const routes = [];
  
  Object.entries(services).forEach(([serviceKey, service]) => {
    provinces.forEach(province => {
      const formattedProvince = formatProvinceForUrl(province);
      routes.push({
        path: `/${service.path}-a-${formattedProvince}`,
        pattern: `/${service.path}-a-:province`,
        province: formattedProvince,
        service: serviceKey,
        title: `${service.title} a ${formatProvinceForDisplay(province)}`,
        description: `${service.description} a ${formatProvinceForDisplay(province)}`
      });
    });
  });
  console.log(routes);
  return routes;
};

export const generateSitemap = () => {
  const baseUrl = 'https://rbcostruzionisrl.it';
  const routes = generateSeoRoutes();
  
  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>${baseUrl}</loc>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  ${routes.map(route => `
  <url>
    <loc>${baseUrl}${route.path}</loc>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  `).join('')}
</urlset>`;

  return xml;
};

// Genera le rotte per React Router
export const seoRoutes = generateSeoRoutes().map(route => ({
  path: route.path,
  element: <Services01 
    location={route.province}
    serviceTitle={services[route.service]?.title || ''}
    seoTitle={route.title || ''}
    description={route.description || ''}
    longDescription={services[route.service]?.longDescription || ''}
    benefits={services[route.service]?.benefits || []}
    features={services[route.service]?.features || []}
  />
})); 